import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COMPONENT_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, COMPONENT_KEY, {
  PROFILE_LANGUAGE: 'Languages',
  SPANISH: 'Spanish',
  PORTUGUESE: 'Portuguese'
});
export default en;